import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const UserMessageVisualization = ({ latestPhrase }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (latestPhrase) {
      const newItems = latestPhrase.split('->').map(item => item.trim());
      setItems(prevItems => {
        const newAdditions = newItems.filter(item => !prevItems.includes(item));
        const rearranged = newItems.filter(item => prevItems.includes(item) && newItems.indexOf(item) !== prevItems.indexOf(item));
        const updatedItems = [...prevItems.filter(item => newItems.includes(item)), ...newAdditions];
        return updatedItems.sort((a, b) => newItems.indexOf(a) - newItems.indexOf(b));
      });
    }
  }, [latestPhrase]);

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex flex-wrap items-center justify-center">
        <AnimatePresence>
          {items.map((item, index) => (
            <React.Fragment key={item}>
              <motion.div
                layout
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="m-2 p-3 bg-teal-500 text-white rounded-lg"
              >
                {item}
              </motion.div>
              {index < items.length - 1 && (
                <motion.svg 
                  className="w-6 h-6 text-gray-400" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5, delay: (index + 0.5) * 0.1 }}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </motion.svg>
              )}
            </React.Fragment>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default UserMessageVisualization;
